// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--ntlMw_OGOqcDbT6R"};